<template>
    <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle
            opacity="0.3"
            cx="75"
            cy="75"
            r="75"
            fill="currentColor" />
        <path
            d="M47.8935 48.1445C44.037 48.1445 40.875 51.3065 40.875 55.163V79.2556C40.875 83.1121 44.037 86.2741 47.8935 86.2741H85.3255C89.182 86.2741 92.344 83.1121 92.344 79.2556V55.163C92.344 51.3065 89.182 48.1445 85.3255 48.1445H47.8935Z"
            fill="currentColor" />
        <path
            d="M62.456 94.8376C62.456 96.0431 63.4689 97.0561 64.6745 97.0561H102.106C103.312 97.0561 104.325 96.0431 104.325 94.8376V70.7451C104.325 69.5395 103.312 68.5266 102.106 68.5266H97.51V63.7266H102.106C105.963 63.7266 109.125 66.8885 109.125 70.7451V94.8376C109.125 98.6941 105.963 101.856 102.106 101.856H64.6745C60.818 101.856 57.656 98.6941 57.656 94.8376V91.403H62.456V94.8376Z"
            fill="currentColor" />
    </svg>
</template>

<script>
export default {
    name: 'SbsVideoPlayerStubIcon',
};
</script>
